import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LanguageSelectorInputComponent } from "../../shared/components/language-selector-input/language-selector-input.component";
import { ConfigService } from '../../core/services/config.service';
import { I18nService } from '../../core/services/i18n.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { AsyncPipe } from '@angular/common';
import { map } from 'rxjs';


@Component({
    selector: 'app-auth-layout',
    imports: [TranslatePipe, LanguageSelectorInputComponent, AsyncPipe],
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss'],
})
export class AuthLayoutComponent {
    private readonly i18nService = inject(I18nService);

    protected languageCode$ = this.i18nService.language$;

    @Input() title: string = '';
    @Input() subtitle: string = '';

    protected onLanguageChange(langCode: string | null) {
        if (langCode) {
            this.i18nService.language = langCode;
        }
    }
}
